import { render, staticRenderFns } from "./ModalDeleteContact.vue?vue&type=template&id=a464ac1c"
import script from "./ModalDeleteContact.vue?vue&type=script&lang=js"
export * from "./ModalDeleteContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports